import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import DateFnsUtils from "@date-io/date-fns";
import store from "store2";

import TypeFilter from "./TypeFilter";
import StoreFilter from "./StoreFilter";

const useStyles = makeStyles((theme) => ({
  searchButton: {
    verticalAlign: "bottom",
    marginLeft: "10px",
    // marginBottom: "10px",
  },
}));

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersDay: {
      day: {
        color: "#A3080C",
      },
      daySelected: {
        backgroundColor: "#A3080C",
        color: "white",
      },
      current: {
        color: "#A3080C",
      },
    },
  },
});

function DateFilter(props) {
  const classes = useStyles();

  // Export component
  let ExportComponent;
  if (props.exportComponent) {
    ExportComponent = props.exportComponent.component;
  }
  let DownloadExportComponent;
  if (props.downloadExportComponent) {
    DownloadExportComponent = props.downloadExportComponent;
  }

  const user = store.session.get("user");

  return (
    <div
      style={{
        marginTop: "10px",
        marginBottom: "10px",
        alignItems: "center",
        display: "flex",
      }}
    >
      <ThemeProvider theme={materialTheme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <>
            <DatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              label="Start Date"
              value={props.startDate}
              onChange={props.setStartDate}
              maxDate={props.endDate}
              autoOk
            />{" "}
            <DatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              label="End Date"
              value={props.endDate}
              onChange={props.setEndDate}
              minDate={props.startDate}
              maxDate={new Date()}
              autoOk
            />
          </>
        </MuiPickersUtilsProvider>

        {props.orderTypeChangeHandler && (
          <TypeFilter
            value={props.orderType}
            onChange={props.orderTypeChangeHandler}
          />
        )}

        {user.role?.id === 2 && props.storeChangeHandler ? (
          <StoreFilter
            value={props.stores}
            onChange={props.storeChangeHandler}
          />
        ) : (
          <></>
        )}

        <Button
          variant="contained"
          onClick={props.filterAction}
          className={classes.searchButton}
        >
          Search
        </Button>

        {props.downloadExportComponent && <DownloadExportComponent />}

        {props.exportComponent && (
          <ExportComponent {...props.exportComponent} />
        )}
      </ThemeProvider>
    </div>
  );
}

export default DateFilter;
